<template>
  <div class="main-page main_bg_color">
    <Nav
      :initFinished="initFinished"
      :gameInfo="gameInfo"
      :activeNav="choiceNav"
      @changeLines="changeLines"
      @kaijiang="isClose = 0"
      @fengpan="isClose = 1"
      @exit="exit"
      @exit-close="exitFalg = false"
      @choiceNav="choiceNavHandel"
      @updateGameInfo="getGameInfo"
      @showNotice="showNoticeBox = true"
      @changePassword="changePassword"
    />

    <div class="main-content">
      <SideBar
        :gameInfo="gameInfo"
        :initFinished="initFinished"
        class="side-bar"
      />
      <div class="main-container">
        <!-- <Radio class="radio-com" :notice="notice" @seeMore="seeMoreNotice()" /> -->
        <div class="subContent">
          <div
            class="title"
            :style="
              currentSubNav === 'yzd'
                ? 'width: 835px;'
                : currentSubNav === 'kd'
                ? 'width: 890px'
                : ''
            "
          >
            <span>
              <span
                v-if="
                  ![
                    'zhzl',
                    'jsbb',
                    'hyrz',
                    'xgmm',
                    'xzmx',
                    'lszd',
                    'jsbb',
                    'kjhm',
                  ].includes(currentSubNav)
                "
                >{{ gameInfo && gameInfo.gameName }}-</span
              >
              {{ currentSubNavLabel }}</span
            >
            <div
              style="display: flex; align-items: center"
              v-if="
                !['zhzl', 'xgmm', 'xzmx', 'lszd', 'jsbb', 'kjhm'].includes(
                  currentSubNav
                )
              "
            >
              <span style="margin-left: 145px">今日输赢</span>
              <span
                style="width: 40px; margin: 0 15px"
                class="result"
                :class="{ lose: userInfo.winorlose < 0 }"
                >{{ userInfo.winorlose }}</span
              >
              <span>{{ gameInfo && gameInfo.nextQihao }}期</span>
              <span style="margin-left: 25px">距离封盘</span>
              <span style="margin-left: 5px" class="result lose">{{
                timeOutText
              }}</span>
              <span style="margin-left: 20px">距离开奖</span>
              <span style="margin-left: 5px" class="result">{{
                kaiJiangTimeOutText
              }}</span>
              <span style="width: 40px; margin-left: 15px; cursor: pointer">{{
                refreshLoading ? "载入" : getRefreshTimeoutText
              }}</span>
            </div>
          </div>
          <el-scrollbar class="subContent-scrollbar">
            <YZD
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'yzd'"
            />
            <EZD
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'ezd'"
            />
            <QD
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'kd'"
            />
            <QX
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'kx'"
            />
            <!-- 快译 -->
            <KY
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'ky'"
            />

            <TXT
              :isClose="isClose"
              :initFinished="initFinished"
              v-if="currentSubNav === 'txtdr'"
            />

            <!-- 开奖号码 -->
            <HistoryPrize
              :initFinished="initFinished"
              v-if="currentSubNav === 'kjhm'"
            />

            <!-- 期期账单 -->
            <PeriodReport
              @goBetDetail="goBetDetail"
              :initFinished="initFinished"
              v-if="currentSubNav === 'lszd'"
            />

            <!-- 下注明细 -->
            <BetDetail
              :goIssue="goIssue"
              :initFinished="initFinished"
              @clean-goIssue="goIssue = ''"
              v-if="currentSubNav === 'xzmx'"
            />

            <!-- 赔率变动表 -->
            <OddsChange v-if="currentSubNav === 'plbdb'" />

            <!-- 会员日志 -->
            <MemberLog
              :initFinished="initFinished"
              v-if="currentSubNav === 'hyrz'"
            />

            <!-- 修改密码 -->
            <ChangePassword
              :initFinished="initFinished"
              v-if="currentSubNav === 'xgmm'"
            />

            <!-- 规则说明 -->
            <PlayRule
              :initFinished="initFinished"
              v-if="currentSubNav === 'wfgz'"
            />

            <!-- 结算报表 -->
            <SettlementReport
              :initFinished="initFinished"
              v-if="currentSubNav === 'jsbb'"
            />

            <PeriodReport
              @goBetDetail="goBetDetail"
              :initFinished="initFinished"
              v-if="choiceNav === 2 && choiceSubNav === -1"
            />

            <ChangePassword
              :initFinished="initFinished"
              v-if="choiceNav === 10 && choiceSubNav === -1"
            />

            <CreditInfo
              :initFinished="initFinished"
              v-if="currentSubNav == 'zhzl'"
            />
          </el-scrollbar>
        </div>
        <Ranking v-if="currentSubNav === 'yzd'" />
        <QDKaiJiang v-if="currentSubNav === 'kd'" />
      </div>
    </div>

    <el-dialog
      class="__custom_dialog__ center-title"
      title="线路切换"
      :visible.sync="showTestSpeed"
      width="488px"
    >
      <div class="change-lines-prop">
        <div class="prop-box">
          <div class="content">
            <div v-for="(item, index) in speedList" :key="index">
              <span>{{ item.name }}</span>
              <span>响应时间{{ item.time }}</span>
              <span class="status">
                <input
                  class="checkbox"
                  type="checkbox"
                  v-model="item.checked"
                  @change="handleChange($event, item)"
              /></span>
            </div>
          </div>
          <div slot="footer" class="btn-group">
            <input
              class="btn normal"
              type="button"
              value="测速"
              @click="testSpeed()"
            />
            <input
              class="btn primary"
              type="button"
              value="确认"
              @click="sureTestSpeed()"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- <div class="see-more-notice-wrap" v-if="showNoticeBox">
      <div class="notice-box">
        <div class="notice-title">公告</div>
        <div class="noticeBox">
          <div class="ncontent">
            {{ noticeDetail.content }}
          </div>

          <div class="btn primary" @click="showNoticeBox = false">确认</div>
        </div>
      </div>
    </div> -->

    <el-dialog
      draggable
      class="__custom_dialog__ notice-dialog"
      title="公告中心"
      width="875px"
      :visible.sync="showNoticeBox"
    >
      <!-- <template slot="'title'">
        <h1 class="title">消息中心</h1>
        <div style="display: flex; align-items: center">
          <div
            @click="handleReadAllNotice"
            class="pointer"
            style="
              margin-right: 25px;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100px;
              height: 30px;
              background: #f7f7f7;
              border-radius: 15px;
              font-size: 14px;
              color: #999;
            "
          >
            <img style="margin-right: 3px" :src="yiduIcon" />
            一键已读
          </div>
          <el-icon class="pointer" @click="noticeVisible = false"
            ><Close
          /></el-icon>
        </div>
      </template> -->
      <!-- <div class="header">
        <el-text class="underline">公告</el-text>
      </div> -->
      <div class="notice-wrapper">
        <div class="left">
          <div
            v-for="item in noticeList"
            :key="item.id"
            class="item pointer"
            :class="{
              active: noticeDetail.id === item.id,
              'not-read': item.isRead === 0,
            }"
            @click="handleClickNotice(item)"
          >
            <div
              style="
                display: flex;
                align-items: center;
                color: #333;
                font-size: 16px;
              "
            >
              <div class="img-wrapper">
                <div class="gonggao-icon"></div>
              </div>
              <span>{{ item.title }}</span>
            </div>
            <span style="color: #999; font-size: 14px">{{
              item.timeStamp | timeFormate
            }}</span>
          </div>
        </div>
        <div class="right" v-if="noticeDetail">
          <h1 class="title">{{ noticeDetail.title }}</h1>
          <div class="time">
            {{ noticeDetail.timeStamp | timeFormate }}
          </div>
          <div class="content">{{ noticeDetail.content }}</div>
          <div class="btn-group">
            <div @click="showNoticeBox = false" class="btn primary">知道了</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="tipBox" v-show="exitFalg">
      <!-- <div class="bg"></div> -->
      <div class="tipContent" style="top: 20vh">
        <div class="title">确认退出</div>
        <div class="close" @click="exitFalg = false">
          <i class="el-icon-close"></i>
        </div>
        <!-- <div class="type tip"></div> -->
        <div class="tcontent">
          <p style="font-size: 13px">确定退出吗？</p>
          <button class="btn primary" @click="exitSure()">确定</button>
        </div>
      </div>
    </div>

    <Music />
  </div>
</template>

<script>
import axios from "axios";
import GameInfo from "@/components/GameInfo";
import SideBar from "@/components/SideBar";
import Nav from "@/components/Nav";
import Music from "@/components/Music";
import Radio from "@/components/Radio";
import YZD from "@/views/SubPage/YZD";
import EZD from "@/views/SubPage/EZD";
import QD from "@/views/SubPage/QuickBet";
import QX from "@/views/SubPage/QuickChoice";
import KY from "@/views/SubPage/QuickTranslate";
import TXT from "@/views/SubPage/TXT";
import BetDetail from "@/views/SubPage/BetDetail";
import PeriodReport from "@/views/SubPage/PeriodReport";
import SettlementReport from "@/views/SubPage/SettlementReport";
import HistoryPrize from "@/views/SubPage/HistoryPrize";
import CreditInfo from "@/views/SubPage/CreditInfo";
import PlayRule from "@/views/SubPage/PlayRule";
import MemberLog from "@/views/SubPage/MemberLog";
import ChangePassword from "@/views/SubPage/ChangePassword";
import OddsChange from "@/views/SubPage/OddsChange";
import Ranking from "@/views/SubPage/Ranking";
import QDKaiJiang from "@/views/SubPage/QuickBet/QDKaiJiang";
import { computed } from "vue";
export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "viewport",
          content:
            "width=device-width,initial-scale=0.6,maximum-scale=1,minimum-scale=0.6,userscalable=no",
        },
      ],
    };
  },
  data() {
    return {
      isVoice: false,
      exitFalg: false,
      noticeDetail: null,
      noticeList: [],
      showNoticeBox: false,
      notice: "",
      goIssue: "",
      gameInfo: null,
      initFinished: false,
      showTestSpeed: false,
      choiceNav: -1,
      choiceSubNav: 1,
      subNavList: [
        {
          subNavId: 1,
          label: "一字定",
        },
        {
          subNavId: 2,
          label: "二字定",
        },
        {
          subNavId: 3,
          label: "快打",
        },
        {
          subNavId: 4,
          label: "快选",
        },
        {
          subNavId: 5,
          label: "TXT导入",
        },
      ],
      isClose: 0,
      choiceHost: "",
      speedList: [],
      settlementReportVisible: false,
      zhzlVisble: false,
      timeOut: 0,
      kaiJiangTimeOut: 0,
      timer: null,
      refreshTimer: null,
      refreshLoading: false,
      refreshTimeout: 5,
    };
  },
  components: {
    GameInfo,
    SideBar,
    Nav,
    Radio,
    Music,
    YZD,
    Ranking,
    EZD,
    QD,
    QDKaiJiang,
    QX,
    KY,
    TXT,
    BetDetail,
    PeriodReport,
    SettlementReport,
    HistoryPrize,
    CreditInfo,
    PlayRule,
    MemberLog,
    ChangePassword,
    OddsChange,
  },
  computed: {
    currentSubNav: {
      get() {
        return this.$store.state.currentSubNav;
      },
      set(val) {
        this.$store.state.currentSubNav = val;
      },
    },
    currentSubNavLabel() {
      const arr = [
        {
          code: "xgmm",
          name: "修改密码",
        },
        {
          code: "zhzl",
          name: "信用资料",
        },
        {
          code: "xzmx",
          name: "下注明细",
        },
        {
          code: "lszd",
          name: "历史账单",
        },
        {
          code: "jsbb",
          name: "结算报表",
        },
        {
          code: "kjhm",
          name: "开奖号码",
        },
        {
          name: "一字定",
          code: "yzd",
        },
        {
          name: "二字定",
          code: "ezd",
        },
        {
          name: "快打",
          code: "kd",
        },
        {
          name: "快选",
          code: "kx",
        },
        {
          name: "快译",
          code: "ky",
        },
        {
          name: "赔率变动表",
          code: "plbdb",
        },
        {
          name: "txt导入",
          code: "txtdr",
        },
        {
          name: "操作日志",
          code: "hyrz",
        },
      ];
      const currentNav = arr.find((item) => item.code === this.currentSubNav);
      return currentNav ? currentNav.name : "";
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    timeOutText() {
      let timeStr = "00:00:00";
      if (this.timeOut > 0) {
        let seconds = (this.timeOut * 1) % 60;
        let minutes = Math.floor((this.timeOut * 1) / 60);
        seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
        minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
        timeStr = `00:${minutes}:${seconds}`;
      }
      return timeStr;
    },
    kaiJiangTimeOutText() {
      let timeStr = "00:00:00";
      if (this.kaiJiangTimeOut > 0) {
        let seconds = (this.kaiJiangTimeOut * 1) % 60;
        let minutes = Math.floor((this.kaiJiangTimeOut * 1) / 60);
        seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
        minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
        timeStr = `00:${minutes}:${seconds}`;
      }
      return timeStr;
    },
    getRefreshTimeoutText() {
      return `${this.refreshTimeout}秒`;
    },
  },
  watch: {
    choiceNav(newVal, oldVal) {
      if (oldVal == 1) {
        this.goIssue = "";
      }
      if (newVal !== -1) {
        this.choiceSubNav = -1;
      }
    },
    choiceSubNav(newVal, oldVal) {
      if (newVal !== -1) {
        this.choiceNav = -1;
      }
    },
  },
  async created() {
    this.setTitle();
    this.getUserInfo();
    await this.getGameInfo();
    this.getNotice();
    this.initFinished = true;
    this.handleRefreshGameInfo();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }
  },
  methods: {
    handleRefreshGameInfo() {
      const _this = this;
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
      this.refreshTimer = setTimeout(() => {
        this.refreshTimeout--;
        if (this.refreshTimeout <= 0) {
          this.refreshLoading = true;
          this.getGameInfo(() => {
            this.refreshTimeout = 5;
            _this.refreshLoading = false;
            this.handleRefreshGameInfo();
          });
        } else {
          this.handleRefreshGameInfo();
        }
      }, 1000);
    },
    handleChange(e, item) {
      const checked = e.target.value;
      this.speedList.forEach((i) => this.$set(i, "checked", false));
      this.$set(item, "checked", checked);
      this.choiceHost = item.host;
    },
    getUserInfo() {
      this.$store.state.userInfo = JSON.parse(
        sessionStorage.getItem("userInfo")
      );
    },
    countDown() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.timeOut > 0) {
          this.timeOut--;
        } else if (this.timeOut == 0) {
          this.timeOut = -1;
        }
        if (this.timeOut == 0) {
          this.$emit("fengpan");
        }
        this.kaiJiangTimeOut--;
        if (this.kaiJiangTimeOut <= 0) {
          clearInterval(this.timer);
        }
        this.countDown();
      }, 1000);
    },
    async getGameInfo(cb) {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
      };
      let result = await this.$http.postAxiosMethod("/user/gameinfo", data, {
        hideLoading: true,
      });
      if (result.code == 0) {
        sessionStorage.setItem("gameInfo", JSON.stringify(result.data));
        this.isClose = result.data[0].isClose;
        this.$store.state.gameInfo = result.data;
        this.gameInfo = result.data[0];
        this.timeOut = result.data[0].closeTime;
        this.kaiJiangTimeOut =
          result.data[0].nextTime - result.data[0].serverTime;
        this.$BUS.$emit("getGameInfoFinished");
        this.$BUS.$emit("updateUserInfo");
      }
      cb && cb();
      this.countDown();
    },
    changePassword() {
      this.choiceNavHandel("xgmm");
    },
    goBetDetail(issue) {
      this.goIssue = issue;
      this.currentSubNav = "xzmx";
      this.choiceNav = "xzmx";
    },
    setTitle() {
      let title = sessionStorage.getItem("title");
      this.$setDocumentTitle(title);
    },
    choiceNavHandel(nav) {
      if (
        [
          "zhzl",
          "jsbb",
          "lszd",
          "kjhm",
          "xzmx",
          "hyrz",
          "xgmm",
          "wfgz",
        ].includes(nav)
      ) {
        this.currentSubNav = "";
        this.choiceNav = "";
        this.$nextTick(() => {
          this.currentSubNav = nav;
          this.choiceNav = nav;
        });
      } else {
        this.choiceNav = "";
        this.$nextTick(() => {
          this.choiceNav = nav;
        });
      }
      // } else if (nav === 8) {
      //   this.changeLines();
      // } else if (nav === 9) {
      //   this.exit();
      // }
    },
    async changeLines() {
      await this.testSpeed();
      this.showTestSpeed = true;
    },
    sureTestSpeed() {
      if (this.choiceHost && this.choiceHost !== "") {
        let url = this.choiceUrl + "/#/?";
        let parameter = "";

        var sessionKeys = Object.keys(sessionStorage);
        for (let i of sessionKeys) {
          parameter += `${i}=${sessionStorage.getItem(i).replace("&", "%26")}&`;
        }
        url += parameter.substring(0, parameter.length - 1);
        location.href = url;
      }
    },
    async getNotice() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
      };
      let result = await this.$http.postAxiosMethod("/user/notice", data);
      if (result.code == 0) {
        this.noticeList = result.data;
        for (let i of result.data) {
          this.notice += i.content + "；";
          // if(i.type == 1){
          //     this.notice = i
          //     break;
          // }
        }
        this.seeMoreNotice();
      }
    },
    seeMoreNotice() {
      if (this.noticeList.length > 0) {
        this.noticeDetail = this.noticeList[0];
        // this.noticeDetail = this.noticeList.find((i) => i.type == 3);
        this.noticeDetail && (this.showNoticeBox = true);
      }
    },
    handleClickNotice(item) {
      this.noticeDetail = item;
    },
    async testSpeed() {
      let result = await this.$http.postAxiosMethod("/user/speedList");
      if (result.code == 0) {
        this.speedList = result.data;
        result.data.forEach(async (item, index) => {
          let startDate = new Date();
          let res = await axios.post(item.url);
          let endDate = new Date();
          let time = endDate.getTime() - startDate.getTime();
          this.speedList[index] = {
            host: item.host,
            name: item.name,
            url: item.url,
            time,
            checked: false,
          };
          this.speedList = JSON.parse(JSON.stringify(this.speedList));
        });
      }
    },
    exit() {
      this.exitFalg = true;
      // this.$confirm("确定退出系统吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(async (res) => {
      //     // let data = {
      //     //     access_token: this.$store.state.userInfo.access_token,
      //     //     uid: this.$store.state.userInfo.uid,
      //     // }
      //     // let result = await this.$http.postAxiosMethod("/user/loginout", data)
      //     // if(result.code == 0){
      //     sessionStorage.clear();
      //     window.location.href = "/";
      //     // }
      //   })
      //   .catch(() => {});
    },
    async exitSure() {
      sessionStorage.clear();
      window.location.href = "/";
    },
    choiceSubNavHandel(subNav) {
      this.choiceSubNav = subNav.subNavId;
    },
  },
};
</script>

<style lang="scss">
.el-scrollbar {
  height: 100%;
}
.el-scrollbar__wrap {
  overflow-x: auto;
}

.el-scrollbar.subContent-scrollbar {
  // margin-bottom: 200px;
  .el-scrollbar__wrap {
    // margin-bottom: 20px;
    padding-bottom: 35px;
    // max-height: calc(100vh - 220px);
    overflow-x: auto;
  }
}
</style>

<style lang="scss" scoped>
.main-page {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  // height: 100%;
  height: 100vh;
  // overflow: hidden;
  // min-height: 900px;
  min-width: 1400px;
  overflow-x: hidden;
  .side-bar {
    flex-shrink: 0;
  }
  .main-content {
    margin: 10px;
    display: flex;
    width: 100%;
    min-width: 1200px;
    .main-container {
      display: flex;
      justify-content: space-between;
      // margin-left: 20px;
      width: 1210px;
      .radio-com {
        height: 28px;
      }
      .subNav-box {
        width: 100%;
        height: 28px;
        font-size: 14px;
        & > ul {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          & > li {
            height: 100%;
            display: flex;
            align-items: center;
            padding: 0 12px;
            cursor: pointer;
            &.active {
              background-color: #fff;
            }
          }
        }
      }
      .subTitle {
        width: 100%;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
      }
      .subContent {
        width: 100%;
        margin-bottom: 25px;
        overflow: hidden;
        > .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          height: 30px;
          line-height: 30px;
          color: #fff;
          border-radius: 10px 10px 0 0;
          background: var(--new-bg-primary);
          .result {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 19px;
            border-radius: 4px;
            color: var(--new-success);
            background: var(--new-bg-white);
            width: 60px;
            white-space: nowrap;
            &.lose {
              color: var(--new-error);
            }
          }
        }
      }
    }
  }

  .change-lines-prop {
    // position: fixed;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // left: 0;
    // z-index: 2000;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // background: rgba(0, 0, 0, 0.5);
    .prop-box {
      // background: #ffffff;
      // box-shadow: 0px 4px 3px 0px rgba(3, 6, 43, 0.23);
      // border-radius: 10px;
      // .title {
      //   position: relative;
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      //   width: 400px;
      //   height: 30px;
      //   background: var(--primary-table-header-color);
      //   border-radius: 10px 10px 0px 0px;
      //   color: #fff;
      //   font-size: 13px;
      //   font-weight: bold;
      //   i {
      //     position: absolute;
      //     top: 50%;
      //     right: 25px;
      //     transform: translateY(-50%);
      //     font-size: 16px;
      //     font-weight: bold;
      //     cursor: pointer;
      //   }
      //   & > span {
      //     display: flex;
      //     justify-content: center;
      //     align-items: center;
      //     img {
      //       margin-right: 28px;
      //     }
      //   }
      // }
      .content {
        font-size: 14px;
        & > div {
          display: flex;
          align-items: center;
          justify-content: space-around;
          height: 35px;
          color: #111b23;
          border: 1px solid var(--new-border);
          &:nth-child(1) {
            margin-top: 10px;
          }
          &:not(:last-child) {
            border-bottom: none;
          }
          span {
            height: 35px;
            line-height: 35px;
            display: inline-block;
            text-align: center;
            width: 33.3%;
            &:nth-child(1) {
              background: var(--new-bg-table-header-main);
              border-right: 1px solid var(--new-border);
              border-bottom: 1px solid var(--new-border);
              width: 30%;
            }
            &:nth-child(2) {
              border-right: 1px solid var(--new-border);
              width: 35%;
            }
            &:nth-child(3) {
              padding-left: 20px;
              text-align: left;
              width: 35%;
            }
          }
          &.label {
            background: var(--new-bg-table-header-main);
          }
        }
      }
      .btn-group {
        margin-top: 20px;
        // padding-right: ;
        text-align: center;
        input[type="button"] {
          padding: 0;
          width: 100px;
          height: 30px;
          line-height: 30px;
          // border-radius: 2px;
          // color: #fff;
          margin-right: 15px;
          // &:nth-child(1) {
          //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
          // }
          // &:nth-child(2) {
          //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
          // }
        }
      }
    }
  }
}
.notice-dialog {
  .header {
    margin-bottom: 15px;
  }
  .notice-wrapper {
    display: flex;
    height: 550px;
    .left {
      width: 368px;
      flex-shrink: 0;
      height: 100%;
      overflow-y: auto;
      > .item {
        margin-bottom: 15px;
        padding: 18px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 70px;
        border-radius: 10px;
        .img-wrapper {
          position: relative;
          margin-right: 15px;
        }
        &.not-read {
          .img-wrapper {
            &::after {
              content: "";
              position: absolute;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #ed1111;
              right: 0;
              top: 0;
              transform: translate(50%, -50%);
            }
          }
        }

        &.active {
          background: var(--new-primary-third-color);
        }
      }
    }
    .right {
      position: relative;
      text-align: left;
      margin-left: 25px;
      padding: 18px;
      flex: 1;
      height: 100%;
      border-radius: 10px;
      border: 1px solid #f0f0f0;
      padding-bottom: 30p;
      > .title {
        margin-bottom: 10px;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }
      > .time {
        margin-bottom: 25px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
      > .content {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 18px;
      }
      > .btn-group {
        text-align: right;
        padding-right: 30px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 30px;
      }
    }
  }
}
</style>
